import { apiSlice } from './apiSlice';

export interface ActiveCurrency {
  code: string;
  name: string;
  symbol: string | null;
}

export const currencyApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getActiveCurrency: builder.query<{ success: boolean; data: ActiveCurrency | null }, void>({
      query: () => ({
        url: '/currency/active',
        method: 'GET',
      }),
    }),
  }),
});

export const { useGetActiveCurrencyQuery } = currencyApi;
